import {
  FEEDBACK_FORM_PAGE_REQUEST,
  FEEDBACK_FORM_SUBMIT_FEEDBACK,
  FEEDBACK_FORM_INVALID_FEEDBACK,
  FEEDBACK_FORM_SUCCESS_SUBMIT,
  FEEDBACK_FORM_SET_DATA_CHECK_FEEDBACK_TOKEN,
  FEEDBACK_FORM_SHOW_FORM
} from './constants'

export function feedbackFormPageRequest (params) {
  return {type: FEEDBACK_FORM_PAGE_REQUEST, payload: {params}}
}

export function submitFeedback (data) {
  return {type: FEEDBACK_FORM_SUBMIT_FEEDBACK, payload: {data}}
}

export function isInvalidFeedback (invalidFeedback) {
  return {type: FEEDBACK_FORM_INVALID_FEEDBACK, payload: {invalidFeedback}}
}

export function isSubmitSuccess (submitSuccess) {
  return {type: FEEDBACK_FORM_SUCCESS_SUBMIT, payload: {submitSuccess}}
}

export function setDataCheckFeedbackToken (dataFeedbackToken) {
  return {type: FEEDBACK_FORM_SET_DATA_CHECK_FEEDBACK_TOKEN, payload: {dataFeedbackToken}}
}

export function showForm (showFeedbackForm) {
  return {type: FEEDBACK_FORM_SHOW_FORM, payload: {showFeedbackForm}}
}



// WEBPACK FOOTER //
// ./app/actions/feedbackForm/index.js